export default __webpack_public_path__ + "static/media/terms2_on.e8977c89.svg";